import { FunctionComponent, memo, useMemo } from 'react';
import { useSessionManagement } from 'src/services/auth/session/hooks/useSessionManagement';
import { IDP_LOGOUT_ENDPOINT } from 'src/services/auth/constants';
import { HEADER_VERSIONS } from './constants';
import { useZillowNavbarState } from './hooks/useZillowNavbarState';
import { ZillowNavbar } from './ZillowNavbar';
import { UserNavigationData } from './components/AccountManagement/types/UserNavigationData';

type WiredZillowNavbarProps = {
    /**
     * The header version to render
     */
    version: HEADER_VERSIONS;
};

export const WiredZillowNavbar: FunctionComponent<WiredZillowNavbarProps> = memo(({ version }) => {
    const { staticDomainConfig, zhlHost, links } = useZillowNavbarState();
    const { startSession, endSession, session } = useSessionManagement();
    const userNavigationData: UserNavigationData | null = useMemo(
        () =>
            session
                ? {
                      userAvatarData: {
                          displayName: session?.user?.name,
                          email: session?.user?.email,
                          photo: session?.user?.image,
                      },
                      navLinks: {},
                  }
                : null,
        [session]
    );
    return (
        <ZillowNavbar
            userNavigationData={userNavigationData}
            useAuth0
            onAuth0SignIn={() => startSession('Navbar Sign In')}
            onAuth0SignOut={async () => {
                endSession('Navbar Sign Out', {
                    callbackUrl: IDP_LOGOUT_ENDPOINT,
                });
            }}
            version={version}
            zhlHost={zhlHost}
            links={links}
            staticDomainConfig={staticDomainConfig}
        />
    );
});
